"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldsToMap = exports.actsLikeDate = exports.getFieldChoiceValueByLabel = exports.getFieldChoiceByLabel = exports.replaceValueInNestedField = exports.getAppFieldBySlug = exports.replaceValueInList = exports.getFieldParamValue = exports.getMaxLength = exports.needUseDefaultFieldValue = exports.isValidFieldSlug = exports.generateSlug = exports.getPrimaryField = exports.isFieldUnique = exports.isFieldRequired = exports.isEditingAllowed = exports.isFieldNested = exports.isFieldSystem = exports.isFieldPrimary = exports.getFieldChoiceLabel = exports.getFieldChoiceByValue = exports.getAppStructureFieldBySlug = exports.getValueFromRecordByField = exports.resolveFieldBySlug = exports.getFieldSlug = void 0;
const uuid_1 = require("uuid");
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
/**
 * get full field slug
 *
 * @param field  application structure field.
 *
 * @example
 *
 * getFieldSlug(field)
 * getFieldSlug(nestedFields)
 */
const getFieldSlug = (field) => {
    const parent = field === null || field === void 0 ? void 0 : field.parent;
    const slug = field === null || field === void 0 ? void 0 : field.slug;
    return parent != null ? `${parent.slug}.${slug}` : slug;
};
exports.getFieldSlug = getFieldSlug;
/**
 * get parent and child application fields by full slug
 *
 * @param fields  application structure fields list.
 * @param fullSlug  application structure field slug.
 *
 * @example
 *
 * parseFieldBySlug(fields, "address")
 * parseFieldBySlug(fields, "address.city")
 */
const resolveFieldBySlug = (fields = [], fullSlug = "") => {
    var _a;
    if (!fields || !fullSlug) {
        return [undefined, undefined];
    }
    const [parentSlug, childSlug] = fullSlug.split(".");
    const parentField = fields.find(({ slug }) => slug === parentSlug);
    const nested = (_a = parentField === null || parentField === void 0 ? void 0 : parentField.nested) !== null && _a !== void 0 ? _a : [];
    const childField = childSlug
        ? nested.find(({ slug }) => slug === childSlug)
        : undefined;
    // We need to handle case when nested field in textnestedfield has been removed but slug is still present.
    if (isTextNestedField(parentField === null || parentField === void 0 ? void 0 : parentField.field_type) && childSlug && !childField) {
        return [undefined, undefined];
    }
    return [parentField, childField];
};
exports.resolveFieldBySlug = resolveFieldBySlug;
const isTextNestedField = (fieldType) => {
    return (!!fieldType &&
        [
            "textnestedfield",
            "addressfield",
            "fullnamefield",
            "socialnetworkfield",
        ].includes(fieldType));
};
const getValueFromRecordByField = (record, field, customGetFieldLogic) => {
    const fieldLogic = customGetFieldLogic
        ? customGetFieldLogic(field.field_type)
        : (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
    return fieldLogic.getFieldValue(field, record);
};
exports.getValueFromRecordByField = getValueFromRecordByField;
/**
 * search application structure field by full slug
 * and return field params
 *
 * @param fields  application structure fields list.
 * @param slug  application structure field slug.
 *
 * @example
 *
 * getAppStructureFieldBySlug(fields, "address")
 * getAppStructureFieldBySlug(fields, "address.city")
 */
const getAppStructureFieldBySlug = (fields = [], slug = "") => {
    var _a;
    if (!fields) {
        return null;
    }
    const [parentField, childField] = (0, exports.resolveFieldBySlug)(fields, slug);
    return (_a = childField !== null && childField !== void 0 ? childField : parentField) !== null && _a !== void 0 ? _a : null;
};
exports.getAppStructureFieldBySlug = getAppStructureFieldBySlug;
/**
 * returns field choice for value
 *
 * @param field  application fields list.
 * @param value  application field slug.
 *
 * @example
 *
 * getFieldChoiceByValue(field, "1")
 * getFieldChoiceByValue(field, "python")
 */
const getFieldChoiceByValue = (field, value) => {
    var _a, _b;
    if (!field) {
        return null;
    }
    const choices = (_a = field.params.choices) !== null && _a !== void 0 ? _a : [];
    return ((_b = choices.find(({ value: choiceValue }) => choiceValue === value)) !== null && _b !== void 0 ? _b : null);
};
exports.getFieldChoiceByValue = getFieldChoiceByValue;
/**
 * returns value of field choice
 *
 * @param field  application fields list.
 * @param value  application field slug.
 *
 * @example
 *
 * getFieldChoiceLabel(field, "1")
 * getFieldChoiceLabel(field, "python")
 */
const getFieldChoiceLabel = (field, value) => {
    var _a;
    const choice = (0, exports.getFieldChoiceByValue)(field, value);
    return (_a = choice === null || choice === void 0 ? void 0 : choice.label) !== null && _a !== void 0 ? _a : "";
};
exports.getFieldChoiceLabel = getFieldChoiceLabel;
/**
 * returns if field is a primary one
 *
 * @param field  application structure field.
 *
 * @example
 *
 * isFieldPrimary(field)
 */
const isFieldPrimary = (field) => {
    var _a;
    return !!((_a = field === null || field === void 0 ? void 0 : field.params.primary) !== null && _a !== void 0 ? _a : false);
};
exports.isFieldPrimary = isFieldPrimary;
/**
 * returns True if field is a system one
 *
 * @param field application structure field.
 *
 * @example
 *
 * isFieldSystem(field)
 */
const isFieldSystem = (field) => {
    var _a;
    return !!((_a = field.params.system) !== null && _a !== void 0 ? _a : false);
};
exports.isFieldSystem = isFieldSystem;
/**
 * returns True if field is a nested one
 *
 * @param field application structure field.
 *
 * @example
 *
 * isFieldNested(field)
 */
const isFieldNested = (field) => {
    return !!((field === null || field === void 0 ? void 0 : field.parent) != null);
};
exports.isFieldNested = isFieldNested;
/**
 * Determines whether editing is allowed for a specified nested field.
 *
 * @param field - The field to check for editing permissions.
 * @returns - A boolean indicating whether editing is allowed for a nested field.
 */
const isEditingAllowed = (field) => {
    var _a;
    const parentField = (_a = field.parent) !== null && _a !== void 0 ? _a : field;
    const parentFieldLogic = (0, fields_logic_registry_1.getFieldLogic)(parentField.field_type);
    const parentInlineEditRules = parentFieldLogic.getInlineEditRules(parentField);
    return (0, exports.isFieldNested)(field) && parentInlineEditRules.allowEditNestedFields;
};
exports.isEditingAllowed = isEditingAllowed;
/**
 * returns if field is required
 *
 * @param field  application structure field.
 *
 * @example
 *
 * isFieldRequired(field)
 */
const isFieldRequired = (field) => {
    var _a;
    return !!((_a = field.params.required) !== null && _a !== void 0 ? _a : false);
};
exports.isFieldRequired = isFieldRequired;
/**
 * Returns True if field should be unique
 *
 * @param field  application structure field.
 *
 * @example
 *
 * isFieldUnique(field)
 */
const isFieldUnique = (field) => {
    var _a;
    return (_a = field.params.unique) !== null && _a !== void 0 ? _a : false;
};
exports.isFieldUnique = isFieldUnique;
/**
 * returns a primary field of the given structure
 *
 * @param structure  application structure
 *
 */
const getPrimaryField = (structure) => {
    return structure.find(exports.isFieldPrimary);
};
exports.getPrimaryField = getPrimaryField;
/**
 * Returns randomly generated slug for new fields.
 *
 * Slugs should look like programming language variables: they should start with ascii letter
 * and not contain hyphens (-).
 */
const generateSlug = () => `s${(0, uuid_1.v4)().replace("-", "").slice(0, 9)}`;
exports.generateSlug = generateSlug;
/**
 * Returns True if slug is valid.
 * Valid slug starts with lowercase 's', has 10 characters and contains only lowercase letters and numbers.
 */
const isValidFieldSlug = (slug) => {
    return /^s[a-z0-9]{9}$/.test(slug);
};
exports.isValidFieldSlug = isValidFieldSlug;
/**
 * Check if need use default field value.
 * We can't use default field value for unique field
 */
function needUseDefaultFieldValue(field, value) {
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
    return ((0, exports.isFieldRequired)(field) &&
        fieldLogic.isValueEmpty(value, field) &&
        !fieldLogic.isDefaultEmpty(field) &&
        !(0, exports.isFieldUnique)(field));
}
exports.needUseDefaultFieldValue = needUseDefaultFieldValue;
const getMaxLength = (field) => {
    const paramValue = (0, exports.getFieldParamValue)(field, "max_length");
    if (paramValue !== null) {
        return paramValue;
    }
    const fieldType = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
    return fieldType.defaultMaxLength;
};
exports.getMaxLength = getMaxLength;
/**
 * returns param value of field
 *
 * @param fields      application structure field
 * @param paramName   name of field param
 *
 * @example
 *
 * getFieldParamValue(field, "max_length")
 */
const getFieldParamValue = ({ params }, paramName) => {
    return params[paramName];
};
exports.getFieldParamValue = getFieldParamValue;
/**
 * Allows to replace part of the list.
 *
 * We need to find the value in the list from the source group and replace this part with
 * the value from the target group. All other values must remain unchanged.
 * Also, all values must remain unique.
 *
 * @example
 * record: { multi_select: ['one', 'two', 'three'] }
 * sourceValue: ['one']
 * targetValue: ['four']
 * Result: ['four', 'two', 'three']
 */
const replaceValueInList = (field, record, sourceValue, targetValue) => {
    const value = (0, exports.getValueFromRecordByField)(record, field);
    // we need to process only filled list, otherwise we return empty list
    if (!targetValue.length) {
        return [];
    }
    // there is nothing to replace
    if (!value) {
        return targetValue;
    }
    const recordValue = [...value];
    // replace values
    const sourceItem = sourceValue[0];
    const sourceItemIndex = recordValue.findIndex((item) => (0, react_fast_compare_1.default)(item, sourceItem));
    recordValue.splice(sourceItemIndex, 1, ...targetValue);
    // return only unique values
    return [...new Set(recordValue).values()];
};
exports.replaceValueInList = replaceValueInList;
/**
 * search application field by full slug
 *
 * @param fields  application fields list.
 * @param slug  application field slug.
 *
 * @example
 *
 * getAppFieldBySlug(fields, "address")
 * getAppFieldBySlug(fields, "address.city")
 */
const getAppFieldBySlug = (fields, slug) => {
    const [parentField, childField] = (0, exports.resolveFieldBySlug)(fields, slug);
    return (childField && parentField
        ? {
            ...childField,
            label: `${parentField.label}: ${childField.label}`,
            parent: parentField,
        }
        : parentField);
};
exports.getAppFieldBySlug = getAppFieldBySlug;
/**
 * Allows to replace the value in the record for parent or nested field.
 *
 * We can replace the value of the nested field by simply passing the nested field
 * as an argument and string value
 * Otherwise we specify parent field and target value as FullNameFieldValue
 *
 * @example
 * record: { full_name: {first_name: 'Mikhail', last_name: 'Zykov'} }
 * sourceValue: 'Mikhail'
 * targetValue: 'Gena'
 * Result: {first_name: 'Gena', last_name: 'Zykov'}
 */
const replaceValueInNestedField = (field, record, targetValue) => {
    // if the field is a parent, and the value is a string, then we got the wrong values.
    // We need to return initial record value
    if (!field.parent) {
        return (0, exports.getValueFromRecordByField)(record, field);
    }
    // process nested field
    const parentField = field.parent;
    return {
        ...record[parentField.slug],
        [field.slug]: targetValue,
    };
};
exports.replaceValueInNestedField = replaceValueInNestedField;
/**
 * returns field choice for label
 *
 * @param field  application field.
 * @param label  choice's label.
 *
 * @example
 *
 * getFieldChoiceByLabel(field, "Python")
 */
const getFieldChoiceByLabel = (field, label) => {
    var _a, _b;
    if (!field) {
        return null;
    }
    const choices = (_a = field.params.choices) !== null && _a !== void 0 ? _a : [];
    return ((_b = choices.find(({ label: choiceLabel }) => choiceLabel === label)) !== null && _b !== void 0 ? _b : null);
};
exports.getFieldChoiceByLabel = getFieldChoiceByLabel;
/**
 * returns field choice for label
 *
 * @param field  application field.
 * @param label  choice's label.
 *
 * @example
 *
 * getFieldChoiceValueByLabel(field, "Python")
 */
const getFieldChoiceValueByLabel = (field, label) => {
    var _a;
    if (!field) {
        return "";
    }
    const choice = (0, exports.getFieldChoiceByLabel)(field, label);
    return (_a = choice === null || choice === void 0 ? void 0 : choice.value) !== null && _a !== void 0 ? _a : "";
};
exports.getFieldChoiceValueByLabel = getFieldChoiceValueByLabel;
/**
 * Check if field itself is date or links to date field.
 */
const actsLikeDate = (appField) => {
    var _a, _b;
    const targetField = appField.params.target_field_structure;
    if (targetField) {
        const isValidTargetField = (_a = targetField.params.valid) !== null && _a !== void 0 ? _a : true;
        return isValidTargetField ? (0, exports.actsLikeDate)(targetField) : false;
    }
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(appField.field_type);
    const isValidField = (_b = appField.params.valid) !== null && _b !== void 0 ? _b : true;
    return isValidField && fieldLogic.isDate;
};
exports.actsLikeDate = actsLikeDate;
const fieldsToMap = (fields) => {
    var _a;
    const fieldsMap = new Map();
    for (const field of fields) {
        fieldsMap.set(field.slug, field);
        for (const nestedField of (_a = field.params.nested) !== null && _a !== void 0 ? _a : []) {
            fieldsMap.set(`${field.slug}.${nestedField.slug}`, {
                ...nestedField,
                parent: field,
            });
        }
    }
    return fieldsMap;
};
exports.fieldsToMap = fieldsToMap;
